import * as change from 'change-case';
import count from 'pluralize';

const transform = (data: any, func: (key: string) => string): any => {
  if (typeof data === 'string') return func(data);

  return Object.entries(data).reduce((current, [key, value]: [string, any]) => Object.assign(current, { [func(key)]: value }), {});
};

const factory = (func: (key: string) => string) => (data: any) => transform(data, func);

export const camel = factory(change.camelCase);
export const constant = factory(change.constantCase);
export const dot = factory(change.dotCase);
export const kebab = factory(change.kebabCase);
export const no = factory(change.noCase);
export const pascal = factory(change.pascalCase);
export const path = factory(change.pathCase);
export const sentence = factory(change.sentenceCase);
export const snake =  factory(change.snakeCase);
export const capital = factory(change.capitalCase);

export const singular = factory(count.singular);
export const plural = factory(count.plural);

const mapping: Record<string, (data: any) => any> = { camel, constant, dot, kebab, no, pascal, path, sentence, snake, capital, singular, plural };
export const to = (method: string, data: any) => (mapping[method]?.(data) ?? data);

